module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"priceLegend":"Overridden price","noPriceLegend":"The price has not been overridden","specialLegend":"The product was set special in the menu","rankLegend":"The product\u0027s position was set first"},"es":{"priceLegend":"Precio sobreescrito","noPriceLegend":"Precio no sobreescrito","specialLegend":"Producto especial en menú","rankLegend":"Producto en primera posición del menú"}}')
  delete Component.options._Ctor
}
